var o = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function l(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
export {
  o as commonjsGlobal,
  l as getDefaultExportFromCjs
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/_virtual/_commonjsHelpers.js
// module id = 858
// module chunks = 67